import React from 'react';
import { useScanQrcodeStore } from '@/store';
import { STAMP_STATUS } from '@/constants';

import StampCodeBlocked from '@/components/common/StampCodeBlocked';
import StampUnauthorized from '@/components/elements/StampUnauthorized';
import NewStampCode from '@/components/common/NewStampCode';

const StampScanErrorView: React.FC = () => {
  const { stamp_code } = useScanQrcodeStore();
  const stampCodeStatus = stamp_code?.status || '';

  const renderErrorComponent = () => {
    switch (stampCodeStatus) {
      case STAMP_STATUS.NEW:
        return <NewStampCode />;
      case STAMP_STATUS.BLOCKED:
        return <StampCodeBlocked />;
      default:
        return <StampUnauthorized />;
    }
  };

  return <>{renderErrorComponent()}</>;
};

export default StampScanErrorView;
